import { useMemo } from 'react';
import {
  GetFhirAppointmentDiagnosticReportOutput,
  Hasura_Dnavisit_Test_Statuses_Enum,
  useGetDiagnosticReportsByPatientQuery,
  useGetProviderDiagnosticReportsByPatientQuery,
} from 'graphql/generated/hasura';
import { useAuth } from 'auth/context/AuthContext';
import { Roles } from '../../firebase/interfaces';

type Params = {
  patientId?: string;
  appointmentId?: string;
};

export const usePastTestKitsReports = ({
  patientId,
  appointmentId,
}: Params) => {
  const { user } = useAuth();
  const isProvider = user?.role === Roles.PROVIDER;

  const shouldSkip = !patientId || !appointmentId || !user?.role;

  const { loading: patientLoading, data: patientData } =
    useGetDiagnosticReportsByPatientQuery({
      skip: shouldSkip || isProvider,
      variables: {
        patientCodexId: patientId as string,
        exceptAppointmentCodexId: appointmentId as string,
        state: [Hasura_Dnavisit_Test_Statuses_Enum.Complete],
      },
    });

  const { loading: providerLoading, data: providerDate } =
    useGetProviderDiagnosticReportsByPatientQuery({
      skip: shouldSkip || !isProvider,
      variables: {
        patientCodexId: patientId as string,
        exceptAppointmentCodexId: appointmentId as string,
        state: [Hasura_Dnavisit_Test_Statuses_Enum.Complete],
      },
    });

  const loading = patientLoading || providerLoading;
  const diagnosticReports: GetFhirAppointmentDiagnosticReportOutput[] = useMemo(
    () =>
      (providerDate || patientData)?.getDiagnosticReportsByPatient
        ?.diagnosticReports ?? [],
    [providerDate, patientData],
  );

  return {
    diagnosticReports,
    loading,
    isProvider,
  };
};
